export default __webpack_public_path__ + "static/media/google-play-badge.6463386b.svg";